<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content" @click.stop>
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">Verificação de Dois Fatores</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body text-center p-4">
        <div class="icon-container mb-4">
          <div class="whatsapp-icon-circle">
            <i class="fab fa-whatsapp"></i>
          </div>
        </div>

        <p class="text-secondary mb-4">
          Enviamos um código de 6 dígitos para o seu <strong>WhatsApp</strong> e
          para o seu <strong>e-mail</strong>. Por favor, insira-o abaixo para
          confirmar a ativação:
        </p>

        <div class="code-input-wrapper mb-4">
          <input
            v-model="internalCode"
            type="text"
            maxlength="6"
            placeholder="000000"
            class="form-control code-input"
            @keyup.enter="verify"
            ref="codeInput"
          />
        </div>

        <p class="text-xs text-secondary mt-2 mb-4">
          Não recebeu o código? 
          <a href="javascript:;" class="text-primary font-weight-bold" @click="$emit('resend')">
            Reenviar Código
          </a>
        </p>

        <div class="button-field mt-4">
          <button
            @click="verify"
            class="btn submit-button"
            :disabled="loading || internalCode.length < 6"
          >
            {{ loading ? 'Validando...' : 'Confirmar Ativação' }}
          </button>
          <button @click="closeModal" class="btn cancel-button" :disabled="loading">
            Cancelar
          </button>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "TwoFAModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalCode: "",
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.internalCode = "";
        this.$nextTick(() => {
          if (this.$refs.codeInput) this.$refs.codeInput.focus();
        });
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    verify() {
      if (this.internalCode.length === 6) {
        this.$emit("verify", this.internalCode);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 450px;
  max-width: 95%;
  background: white;
  border-radius: 16px;
  padding: 24px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f2f5;
  padding-bottom: 15px;
}

.dialog-title {
  font-size: 20px;
  font-weight: 700;
  color: #344767;
  margin: 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  color: #67748e;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #344767;
  }
}

.icon-container {
  display: flex;
  justify-content: center;
}

.whatsapp-icon-circle {
  width: 70px;
  height: 70px;
  background-color: #f0fdf4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #22c55e;
  font-size: 36px;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);
}

.code-input-wrapper {
  display: flex;
  justify-content: center;
}

.code-input {
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 8px;
  height: 60px;
  border-radius: 12px;
  border: 2px solid #e9ecef;
  background-color: #f8f9fa;
  color: #344767;
  transition: all 0.2s;
  width: 100%;
  max-width: 250px;

  &:focus {
    border-color: #661cb0;
    background-color: white;
    box-shadow: 0 0 0 2px rgba(102, 28, 176, 0.1);
    outline: none;
  }

  &::placeholder {
    letter-spacing: normal;
    font-size: 24px;
    opacity: 0.3;
  }
}

.button-field {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.submit-button {
  background-color: #661cb0;
  color: white;
  border-radius: 10px;
  height: 48px;
  font-weight: 600;
  font-size: 16px;
  border: none;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #7b23d3;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 28, 176, 0.2);
  }

  &:disabled {
    background-color: #d2d6da;
    cursor: not-allowed;
  }
}

.cancel-button {
  background-color: transparent;
  color: #67748e;
  border-radius: 10px;
  height: 48px;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid #e9ecef;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #f8f9fa;
    color: #344767;
    border-color: #d2d6da;
  }
}

.text-primary {
  color: #661cb0 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}
</style>
